module.exports = __webpack_public_path__ + "img/uploadd.c3bb127f.svg";